var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPodcasts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1821 37.4534C67.1832 37.4337 67.185 37.4143 67.185 37.3944V31.2743C67.185 14.0297 53.1944 0 35.9973 0C30.3957 0 24.8979 1.51341 20.0985 4.37625C18.9274 5.07502 20.008 6.88612 21.1794 6.18792C25.6521 3.5197 30.7762 2.10937 35.9973 2.10937C52.0311 2.10937 65.0755 15.1927 65.0755 31.2744V33.4306C64.3071 32.7192 63.3689 32.1895 62.3291 31.9089C62.4779 17.3332 50.7428 4.86984 35.9973 4.86984C21.2788 4.86984 9.48839 17.3285 9.66558 31.9008C8.62734 32.1758 7.68909 32.6991 6.91903 33.4036V31.2744C6.91903 27.1399 7.76798 23.1424 9.44227 19.3932C11.0597 15.7711 13.3613 12.5619 16.283 9.85472C17.2832 8.928 15.8494 7.38042 14.8493 8.30756C11.7177 11.2092 9.25059 14.6496 7.51627 18.5331C5.72034 22.5548 4.80966 26.8415 4.80966 31.2744V37.4545C2.0963 37.8309 0 40.1645 0 42.9798V48.9234C0 51.7461 2.10741 54.0842 4.83103 54.4513C5.2245 57.6972 7.99467 60.221 11.3451 60.221C14.9643 60.221 17.9089 57.2766 17.9089 53.6572V38.2459C17.9089 34.7712 15.1945 31.9202 11.7751 31.6977C11.644 18.3479 22.5492 6.97922 35.9973 6.97922C49.4639 6.97922 60.3232 18.3462 60.2197 31.6956C56.7869 31.9039 54.0575 34.7615 54.0575 38.2459V53.6573C54.0575 57.2766 57.0019 60.2211 60.6213 60.2211C63.97 60.2211 66.7392 57.6997 67.1347 54.4558C69.8749 54.1038 72 51.7579 72 48.9234V42.9796C72 40.1617 69.8993 37.8262 67.1821 37.4534ZM2.10938 48.9234V42.9796C2.10938 41.3409 3.25153 39.9648 4.78125 39.6031V52.2998C3.25153 51.9382 2.10938 50.5621 2.10938 48.9234ZM15.7995 38.2459V53.6573C15.7995 56.1134 13.8012 58.1117 11.3451 58.1117C8.88891 58.1117 6.89062 56.1133 6.89062 53.6572V38.2459C6.89062 35.7898 8.88891 33.7915 11.3451 33.7915C13.8012 33.7915 15.7995 35.7898 15.7995 38.2459ZM65.0756 53.6572C65.0756 56.1133 63.0775 58.1116 60.6213 58.1116C58.1652 58.1116 56.1669 56.1133 56.1669 53.6572V38.2459C56.1669 35.7898 58.1652 33.7915 60.6213 33.7915C63.0775 33.7915 65.0756 35.7898 65.0756 38.2459V53.6572ZM69.8906 48.9234C69.8906 50.5741 68.7317 51.9584 67.185 52.3077V39.5954C68.7317 39.9447 69.8906 41.329 69.8906 42.9798V48.9234Z",
    fill: "url(#paint0_linear_1303_94659)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7978 35.4649H46.4427V30.1008C46.4427 24.3431 41.7582 19.6587 36.0004 19.6587C30.2427 19.6587 25.5582 24.3431 25.5582 30.1008V35.4649H23.203C21.8471 35.4649 20.7441 36.5681 20.7441 37.9239V45.1091C20.7441 49.1947 22.3439 53.0352 25.2485 55.9233C27.1625 57.8263 29.4874 59.1595 32.0196 59.8413V65.3559H28.635C26.8032 65.3559 25.3129 66.8462 25.3129 68.678C25.3129 70.5098 26.8032 72.0003 28.635 72.0003H43.3658C45.1976 72.0003 46.6879 70.51 46.6879 68.6782C46.6879 66.8464 45.1976 65.356 43.3658 65.356H39.9812V59.8306C46.4649 58.0528 51.2568 52.0442 51.2568 44.9529V37.924C51.2567 36.5681 50.1537 35.4649 48.7978 35.4649ZM44.5785 68.6782C44.5785 69.3468 44.0345 69.8909 43.3658 69.8909H28.635C27.9664 69.8909 27.4223 69.3468 27.4223 68.6782C27.4223 68.0095 27.9664 67.4654 28.635 67.4654H43.3658C44.0345 67.4654 44.5785 68.0095 44.5785 68.6782ZM37.8718 65.356H34.1291V60.2522C34.7452 60.3273 35.3696 60.3655 35.9998 60.3655C36.0297 60.3655 36.0598 60.3654 36.0897 60.3653C36.6927 60.3617 37.2871 60.3215 37.872 60.2487L37.8718 65.356ZM49.1473 44.9529C49.1473 52.0863 43.2564 58.2144 36.0775 58.2559C28.9 58.2939 22.8535 52.291 22.8535 45.1093V37.924C22.8535 37.7313 23.0103 37.5745 23.203 37.5745H25.5582V45.1093C25.5582 50.867 30.2427 55.5514 36.0004 55.5514C37.2534 55.5514 38.4813 55.3303 39.6499 54.8944C40.9276 54.4175 40.1903 52.4416 38.9125 52.9179C37.9805 53.2657 37.0008 53.442 36.0004 53.442C31.4056 53.442 27.6675 49.7039 27.6675 45.1093V30.1009C27.6675 25.5063 31.4056 21.7682 36.0004 21.7682C40.5952 21.7682 44.3333 25.5063 44.3333 30.1009V45.1093C44.3333 46.8356 43.8079 48.4933 42.8137 49.9032C42.0279 51.0178 43.7518 52.2332 44.5377 51.1189C45.7838 49.3515 46.4427 47.2734 46.4427 45.1094V37.5746H48.7978C48.9905 37.5746 49.1473 37.7314 49.1473 37.9242V44.9529Z",
    fill: "url(#paint1_linear_1303_94659)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0915 42.0601C34.3694 42.0601 34.3665 44.7363 36.0915 44.7363C37.8134 44.7363 37.8164 42.0601 36.0915 42.0601Z",
    fill: "url(#paint2_linear_1303_94659)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0915 47.4917C34.3694 47.4917 34.3665 50.1679 36.0915 50.1679C37.8134 50.1681 37.8164 47.4917 36.0915 47.4917Z",
    fill: "url(#paint3_linear_1303_94659)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2418 44.8193C38.5198 44.8193 38.5169 47.4956 40.2418 47.4956C41.9639 47.4957 41.9668 44.8193 40.2418 44.8193Z",
    fill: "url(#paint4_linear_1303_94659)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1303_94659",
    x1: -5.31409e-7,
    y1: 1.77994,
    x2: 79.5221,
    y2: 46.9903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1303_94659",
    x1: 20.7441,
    y1: 21.2057,
    x2: 62.1552,
    y2: 32.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1303_94659",
    x1: 34.7988,
    y1: 42.1392,
    x2: 37.9187,
    y2: 43.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1303_94659",
    x1: 34.7988,
    y1: 47.5708,
    x2: 37.9187,
    y2: 49.0039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1303_94659",
    x1: 38.9492,
    y1: 44.8984,
    x2: 42.0691,
    y2: 46.3316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0532222,
    stopColor: "#2496C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#046E9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcasts);
export default __webpack_public_path__ + "static/media/podcasts.5e855d0e7d7fcc29a27661831e8e8b43.svg";
export { ForwardRef as ReactComponent };